module.exports = __webpack_public_path__ + "assets/budget.b8b90df9.svg";